import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { ProfilePassKeySettingsComponent } from './profile-pass-key-settings.component';

class ProfilePasskeySettingsFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;
  username: string;
  displayName: string;
  registeredKeys: any;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  resolver: ComponentFactoryResolver;
  viewContainerRef: ViewContainerRef;
  profilePasskeySettingsComponent: ComponentRef<ProfilePassKeySettingsComponent>;

  constructor(formId: string, payload: object) {

  }
    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    console.log('ProfilePasskeySettingsFormSession: ' + this.formId);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.resolver = (clientContext as any).resolver;
    this.viewContainerRef = (clientContext as any).viewContainerRef;
    this.registeredKeys = clientContext['passkeyDetails'];
  }
  endSession(): void {
    console.log('ProfilePasskeySettingsFormSession - End Session: ' + this.formId);
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    // this.passkeyRegister();
    console.log('ProfilePasskeySettingsFormSession - Input: ' + this.formId);
    const self = this;
    self.viewContainerRef.clear();

    const factory: ComponentFactory<ProfilePassKeySettingsComponent> =
      self.resolver.resolveComponentFactory(ProfilePassKeySettingsComponent);
    self.profilePasskeySettingsComponent = self.viewContainerRef.createComponent(factory);

    self.profilePasskeySettingsComponent.instance.registeredPasskeys = this.registeredKeys;

    self.profilePasskeySettingsComponent.instance.onPasskeyRemoveSubmit = self.onSubmitRemovePasskey.bind(self);
    self.profilePasskeySettingsComponent.instance.onPasskeyRemoveCancel = self.onPasskeySettingsCancel.bind(self);

    return new Promise((resolve, reject) => {
      self.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          self.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {
    console.log('ProfilePasskeySettingsFormSession - Continue ' + this.formId + ' payload:', payload);
  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  private onSubmitRemovePasskey(payload) {
    this.submitBlock(payload);
  }

  private onPasskeySettingsCancel(){

    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'cancel_passkey';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    const redirectUrl = url + appendChar + 'error=' + errorCode + '&error_description=cancel_passkey'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
    const logout = this.clientContext['logout'];
    if (logout) {
      logout().finally(() => { window.location.href = redirectUrl; });
    } else {
      window.location.href = redirectUrl;
    }
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default ProfilePasskeySettingsFormSession;
